import React from 'react';
export function HowItWorks() {
  const steps = [{
    number: '01',
    title: 'Diagnose',
    description: "A quick assessment shows where your team actually stands. Who's effective with AI, who's struggling, and what's getting in the way."
  }, {
    number: '02',
    title: 'Build',
    description: "A multi-week program built around your team's real work. Not slides and theory. Hands-on skills your team applies between sessions and brings back with real questions."
  }, {
    number: '03',
    title: 'Sustain',
    description: 'Your strongest adopters become AI champions who keep the momentum going, maintain a shared toolkit, and help the team keep up as AI evolves. The result compounds long after the engagement ends.'
  }];
  return <section className="w-full bg-white py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-118" data-mp="14i30dr8mibzm">
      <div className="max-w-7xl mx-auto" data-id="element-119" data-mp="19adzwszgbvrn">
        <h2 className="text-3xl md:text-5xl font-bold text-brand-navy mb-10 text-center" data-id="element-120" data-mp="19b5mjeb2mj5s">
          How it works
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-14" data-id="element-121" data-mp="2mml3qnhwe14o">
          {steps.map((step, index) => <div key={index} className="bg-white p-10 rounded-lg border-t-4 border-brand-orange shadow-sm" data-id="element-122" data-mp="31b7l0ur352yj" data-mpi={index}>
              <div className="text-brand-orange font-heading font-bold text-2xl mb-6" data-id="element-123" data-mp="2wjg1332fpvhd">
                {step.number}
              </div>
              <h3 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-124" data-mp="36akcjsswiy7g">
                {step.title}
              </h3>
              <p className="text-brand-gray text-lg leading-relaxed" data-id="element-125" data-mp="3kav4kz5y6iu7">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}